import { activeStrategicAxisTypes, inactiveStrategicAxisTypes, priorityactionsTypes }
  from "../../helpers/selectOptions/implementer/submission"

export const useActiveStrategicAxisTypes = strategicAxis => {

  const activeStrategicAxisForCompare = activeStrategicAxisTypes.map(({ value }) => value) || []

  if (strategicAxis) {
    return activeStrategicAxisForCompare?.includes(strategicAxis)
      ? activeStrategicAxisTypes : inactiveStrategicAxisTypes
  }
  return activeStrategicAxisTypes
}

export const usePriorityactionsTypes = priorityactions => {

  const priorityactionsForCompare = priorityactionsTypes.filter(({ type }) => type === priorityactions) || []

  return priorityactionsForCompare
}